import { AppoinitmentType } from "../types/AppoinitmentType";

export const AppointmentActions = {
  failiureHandler,
  successHandler,
  bookAppointment,
  updateAppointment,
  cancelAppointment,
  reScheduleAppointment,
  getAllAppointment,
  getAppointmentById,
  clearAll,
  confirmAppointment,
  getAllFuturAppointment,
  getAllTodayAppointment,
  getAllPastAppointment,
  updateSuccess,
  getAllSuccess,
  getByIdSuccess,
  getAllWeeklyAppointment,
  getAllTomorrowAppointment,
  blockAppointment,
  errorInBookingAppointment,
  checkInAppointment
};

function bookAppointment(data) {
  return { type: AppoinitmentType.BOOK_APPOINTMENT_REQUEST, data };
}
function confirmAppointment(data) {
  return { type: AppoinitmentType.CONFIRM_APPOINTMENT_REQUEST, data };
}
function updateAppointment(data) {
  return { type: AppoinitmentType.UPDATE_APPOINTMENT_REQUEST, data };
}
function cancelAppointment(data) {
  return { type: AppoinitmentType.CANCEL_APPOINTMENT_REQUEST, data };
}
function reScheduleAppointment(data) {
  return { type: AppoinitmentType.RESCHEDULE_APPOINTMENT_REQUEST, data };
}
function getAllAppointment(data) {
  return { type: AppoinitmentType.GET_ALL_APPOINTMENT_REQUEST, data };
}
function getAllPastAppointment(data) {
  return { type: AppoinitmentType.GET_ALL_PAST_APPOINTMENT_REQUEST, data };
}
function getAllTodayAppointment(data) {
  return { type: AppoinitmentType.GET_ALL_TODAY_APPOINTMENT_REQUEST, data };
}
function getAllFuturAppointment(data) {
  return { type: AppoinitmentType.GET_ALL_FUTRUE_APPOINTMENT_REQUEST, data };
}
function getAppointmentById(id) {
  return { type: AppoinitmentType.GET_APPOINTMENT_BY_ID_REQUEST, id };
}
function clearAll(action) {
  return { type: AppoinitmentType.CLEAR_ALL_STATE };
}
function successHandler(data) {
  return { type: AppoinitmentType.APPOINTMENT_COMMON_SUCCESS, data };
}
function failiureHandler(action) {
  return {
    type: AppoinitmentType.APPOINTMENT_COMMON_FAILIURE,
    message: action,
  };
}

function updateSuccess(data) {
  return { type: AppoinitmentType.UPDATE_APPOINTMENT_SUCCESS, data };
}

function getAllSuccess(data) {
  return { type: AppoinitmentType.GET_ALL_APPOINTMENT_SUCCESS, data };
}

function getByIdSuccess(data) {
  return { type: AppoinitmentType.GET_APPOINTMENT_BY_ID_SUCCESS, data };
}
function getAllTomorrowAppointment(data) {
  return { type: AppoinitmentType.GET_ALL_TOMORROW_APPOINTMENT_REQUEST, data };
}
function getAllWeeklyAppointment(data) {
  return { type: AppoinitmentType.GET_ALL_WEEKLY_APPOINTMENT_REQUEST, data };
}

function blockAppointment(data) {
  return { type: AppoinitmentType.BLOCK_APPOINTMENT_REQUEST, data };
}

function errorInBookingAppointment(data) {
  return { type: AppoinitmentType.ERROR_IN_APPOINTMENT_REQUEST, data };
}

function checkInAppointment(id) {
  return { type: AppoinitmentType.CHECK_IN_PATIENT_REQUEST, id };
}

